@if (errorsDetails$ | async; as errorDetails) {
  @if (!hidden) {
    @for (error of errorDetails; track error) {
      <p>
        @switch (error[0]) {
          @case ('postalCodePattern') {
            {{ customError }}
          }
          @default {
            {{
              prefix + '.' + error[0]
                | transloco: getTranslationParams(error[1])
            }}
          }
        }
      </p>
    }
  }
}
